import React from "react";
import { ProtectedPageWrapper } from "../../../designSystem/layouts/pageWrappers/ProtectedPageWrapper";
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { P } from "../../../designSystem/typography/Body";
import { getActionPlansForActiveUser } from "../../../api/actionPlanClientApi";
import { ActionPlanListView } from '../../../amorg-common/DTOs/ActionPlanListView';
import { PageHeader } from "../../../designSystem/PageHeader";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { MessageCard } from "../../../designSystem/Message";
import { ActionPlanListingPageSectionTable } from "../../_components/activities/ActionPlanListingPageSectionTable";
import { Navigate } from "react-router-dom";

export function UserLandingPage():JSX.Element
{
    const [actionplans, setActionplans] = React.useState<ActionPlanListView[]>([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(function(){
        const getData = async () => {
            setActionplans(await getActionPlansForActiveUser());
            setLoading(false);
        }
        getData();
    }, [])

    return (
        <ProtectedPageWrapper requiredPermissions={['ViewAssignedActionPlans']}>
            <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                        {loading &&
                            <LoadingPageOverlay loading={loading} />
                        }
                        
                        {!loading && 
                            <Content actionplans={actionplans} />
                        }
                    </>
                }
            />
        </ProtectedPageWrapper>
    );
}

function Content(props:{actionplans:ActionPlanListView[]}):JSX.Element
{
    const [redirectId, setRedirectId] = React.useState('');

    if(redirectId !== '')
        return <Navigate to={`/actionplans/${redirectId}`} />

    return (
        <>
            <PageHeader headerText="Handleplaner" headerStyle="secondary-gray" />
            
            {props.actionplans.length === 0 &&
                <MessageCard variant="info">
                    <Flex flexDirection="column" gap={16}>
                        <P>Velkommen som bruger af AMORG</P>
                    
                        <P>Du er endnu ikke tildelt handleplaner eller en rolle med AMO adgang.</P>
                    
                        <P>Hvis du mener dette er en fejl, bør du kontakte din AMO gruppe.</P>
                    </Flex>
                </MessageCard>
            }

            {props.actionplans.length > 0 &&
                <>
                    <P>Du er valgt som ansvarlig for følgende handleplaner</P>

                    <ActionPlanListingPageSectionTable
                        items={props.actionplans}
                        noContentText="Ingen handleplaner tildelt"
                        onClick={(actionPlanId) => setRedirectId(actionPlanId)}
                    />
                </>
            }
        </>
    );
}